module.exports = __webpack_public_path__ + "img/phone.71ff42cc.png";